import { P, match } from "ts-pattern";
import { paletteColorTreatments, paletteColorVariants, rangedColorTreatments, rangedColorVariants, singleTonColorVariants, } from "../../theme";
export const resolveColor = (color, theme) => match([color, color.split(".")])
    .with(["inherit", P._], () => "inherit")
    .with([P.union(...singleTonColorVariants), P._], (value) => theme.palette[value[0]])
    .with([P._, [P.union(...paletteColorVariants), P.union(...paletteColorTreatments)]], (value) => {
    const family = value[1][0];
    const color = value[1][1];
    return theme.palette[family][color];
})
    .with([P._, [P.union(...rangedColorVariants), P.union(...rangedColorTreatments)]], (value) => {
    const rangedFamily = value[1][0];
    const rangeValue = value[1][1];
    return theme.palette[rangedFamily][rangeValue];
})
    .otherwise(() => undefined);
export const getColorStyles = (colorProps, theme) => {
    const { color = "inherit", colorSet = "main", invertColors = false, textColor, bgColor, } = colorProps;
    const colorValue = colorSet;
    const contrastColorValue = colorSet === "main" ? "onMain" : "onContainer";
    const resolvedBgColor = bgColor !== undefined ? resolveColor(bgColor, theme) : undefined;
    const resolvedTextColor = textColor !== undefined ? resolveColor(textColor, theme) : undefined;
    return {
        background: resolvedBgColor
            ? resolvedBgColor
            : color === "inherit"
                ? "inherit"
                : theme.palette[color][invertColors ? contrastColorValue : colorValue],
        color: resolvedTextColor
            ? resolvedTextColor
            : color === "inherit"
                ? "inherit"
                : theme.palette[color][invertColors ? colorValue : contrastColorValue],
    };
};
//# sourceMappingURL=colors.js.map